import type { RightPanelView } from '../hooks/useRightPanelState'

export function getRightPanelRenderState({
  rightPanelView,
  hasTimelineContent,
  hasTripListContent,
}: {
  rightPanelView: RightPanelView
  hasTimelineContent: boolean
  hasTripListContent: boolean
}) {
  const isTimelineView = rightPanelView === 'timeline'
  const isListView = rightPanelView === 'list'

  return {
    shouldShowMap: rightPanelView === 'map',
    shouldShowTimelineEmptyState: isTimelineView && !hasTimelineContent,
    shouldShowTripPlanCanvas: isTimelineView && hasTimelineContent,
    shouldShowListEmptyState: isListView && !hasTripListContent,
    shouldShowListView: isListView && hasTripListContent,
  }
}
